import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';

export interface FlowchartConfirmExitWithUnsavedChangesModalProps {
  nodeName: string;
  onRequestKeepEditing: () => void;
  onRequestLeaveWithoutSaving: () => void;
  onRequestClose: () => void;
}

const DEFAULT_TITLE = 'Discard unsaved edits?';

export default function FlowchartConfirmExitWithUnsavedChangesModal(
  props: FlowchartConfirmExitWithUnsavedChangesModalProps
): JSX.Element {
  const {nodeName} = props;

  return (
    <Modal
      title={DEFAULT_TITLE}
      flexContent={true}
      buttons={[
        {
          text: 'Keep editing',
          submit: false,
          style: ButtonStyle.TERTIARY_GRAY,
          onClick: () => {
            props.onRequestKeepEditing();
            props.onRequestClose();
          },
        },
        {
          text: 'Discard edits',
          submit: true,
          style: ButtonStyle.NEGATIVE,
        },
      ]}
      onRequestSubmit={() => {
        props.onRequestLeaveWithoutSaving();
        props.onRequestClose();
      }}
      onRequestClose={() => {
        props.onRequestKeepEditing();
        props.onRequestClose();
      }}
    >
      <p className={css(styles.message)}>
        If you continue, you will lose your unsaved edits to <strong>{nodeName}</strong>.
      </p>
    </Modal>
  );
}

const styles = StyleSheet.create({
  message: {
    fontSize: '14px',
    margin: 0,
    lineHeight: '20px',
  },
});
